import { IS_LOCAL } from '../../config/env';
import { clientState, photonStats, PhotonApi } from './client';
import { photonApi } from './instance';


export const pollingMonitor = {
  started: false,
};


// Used by PhotonStats.js.
// Check if anything is down. And sends a request to refresh stats so that next poll will have it.
export const checkPhotonStats = ({ addMsg }) => {
  IS_LOCAL && console.log('checking APP STATS...');
  const { photonState } = clientState;
  if (!photonApi.client) {
    console.error('No photon client found');
    return ({ playersOnline: -2, playersInLobby: -2, playersPlaying: -2, photonState });
  }
  if (!clientState.isConnected) {
    console.error('Photon client disconnected');
    return ({ playersOnline: -6, playersInLobby: -6, playersPlaying: -6, photonState });
  }
  try {
    // Asks to refresh stats (no await - returns old stats until next poll)
    requestAppStats({ addMsg });
    return { ...photonStats, photonState };
  } catch (err) {
    console.error('[checkPhotonStats] caught:', err);
    return ({ playersOnline: -3, playersInLobby: -3, playersPlaying: -3, photonState });
  }
};


const requestAppStats = ({ addMsg }) => {
  if (!photonApi.client.loadBalancingPeer) {
    if (photonApi.client.myRoom) {
      const newBalancingClient = photonApi.client.myRoom().loadBalancingClient;
      // alert('Found balancingClient in room. Can sendOperation stats? ' + JSON.stringify(Object.keys(newBalancingClient.nameServerPeer)));
      // alert('Found balancingClient in room. Can sendOperation stats? ' + JSON.stringify(Object.keys(newBalancingClient.masterPeer)));
      // alert('Found balancingClient in room. Can sendOperation stats? ' + JSON.stringify(Object.keys(newBalancingClient.gamePeer)));
      // @@@@@@@@@@@
    }
    console.warn('No loadbalancing peer for photon stats', { bal: photonApi.balancer });
    return;
  }

  if (!photonApi.balancer) {
    photonApi.balancer = photonApi.client.loadBalancingPeer;
    // balnacingPeer status handlers (to manage connection events)
    photonApi.client.loadBalancingPeer.addPeerStatusListener(PhotonApi.PhotonPeer.StatusCodes.connecting, () => {
      addMsg('Connecting...', { id: 'client:balancingpeer' });
    });
    photonApi.client.loadBalancingPeer.addPeerStatusListener(PhotonApi.PhotonPeer.StatusCodes.connect, () => {
      addMsg('Connected', { id: 'client:balancingpeer' });
    });
    photonApi.client.loadBalancingPeer.addPeerStatusListener(PhotonApi.PhotonPeer.StatusCodes.connectFailed, () => {
      addMsg('Failed to connect', { id: 'client:balancingpeer' });
    });
    photonApi.client.loadBalancingPeer.addPeerStatusListener(PhotonApi.PhotonPeer.StatusCodes.disconnect, () => {
      addMsg('Disconnected from server', { id: 'client:balancingpeer' });
    });
    photonApi.client.loadBalancingPeer.addPeerStatusListener(PhotonApi.PhotonPeer.StatusCodes.connectClosed, () => {
      addMsg('Connection to server closed.', { id: 'client:balancingpeer' });
    });
    photonApi.client.loadBalancingPeer.addPeerStatusListener(PhotonApi.PhotonPeer.StatusCodes.timeout, () => {
      addMsg('Connection to server timed out.', { id: 'client:balancingpeer' });
    });
  }

  // ask for stats
  addMsg('Asking for Photon stats..', { id: 'client:getstats', dev: true });
  photonApi.client.loadBalancingPeer.sendOperation(
    PhotonApi.LoadBalancing.Constants.OperationCode.LobbyStats
  );
};
